import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer/footer";
import { useSelector } from "react-redux";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import LoadingPage from "../../Components/layouts/loading";
import { useNavigate } from "react-router";
import { getId } from "../../Components/Functions/word.fun";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import WeatherCard from "./weather_card";
import getFormattedWeatherdata from "../../Components/Functions/whetherDataGet";
import { IoMailOutline } from "react-icons/io5";
import { FaRegAddressCard } from "react-icons/fa";
import { CiCreditCard1 } from "react-icons/ci";
import { FaRegAddressBook } from "react-icons/fa";
import { MdContactPhone } from "react-icons/md";
import { Line } from "react-chartjs-2";
import { useSearchParams } from "react-router-dom";
import "chart.js/auto";

const FarmConstructionAgreement = () => {
  const [clientDetails, setClientDetails] = useState("");
  const navigate = useNavigate();
  const [siteInspectionData, setSiteInspectionData] = useState("");
  const user = useSelector((store) => store.login.user);
  const [quotation, setQuotation] = useState("");
  const [loading, setLoading] = useState(false);
  const [timeLines, setTimeLines] = useState("");
  const [weatherData, setWeatherData] = useState();
  const [profilePercent, setProfilePercent] = useState(0);
  const [pmgData, setPmgData] = useState();
  const [pocData, setPOCData] = useState();

  const [themeSet, setThemeSet] = useState("");
  const [searchParams] = useSearchParams();
  const theme = searchParams.get("theme");

  useEffect(() => {
    setThemeSet(theme);
  }, [theme]);

  useEffect(() => {
    if (
      user.AdditionalRole == "farmer partner" &&
      performRequest("GET", `/pmg/pmg-dashboard/getDashboardData`)
        .then((res) => {
          if (res.status === 200) {
            setPmgData(res?.data);
          } else {
            Toast("error", "Error while getting Leads!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
    );
  }, []);

  useEffect(() => {
    if (user.Name) {
      setLoading(true);
      performRequest("GET", `/clientProject/getCp?name=${user.Name}`)
        .then((res) => {
          if (res.status === 200) {
            if (
              res?.data?.clientProjectsData &&
              res?.data?.clientProjectsData?.length > 0
            ) {
              setClientDetails(res?.data?.clientProjectsData[0]);
            }
          } else {
            Toast("error", "Error while getting Details!");
          }
          setLoading(false);
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  }, [user.Name]);

  useEffect(() => {
    if (clientDetails?.farmPinCode) {
      const getWhether = async () => {
        try {
          const data = await getFormattedWeatherdata({
            zip: `${clientDetails?.farmPinCode},IN`,
            units: "metric",
          });

          if (data) {
            setWeatherData(data);
          } else {
            console.error("Received undefined data");
          }
        } catch (error) {
          console.error("Error fetching weather data:", error);
        }
      };
      getWhether();
    }
  }, [clientDetails?.farmPinCode]);

  useEffect(() => {
    if (user.Name) {
      setLoading(true);
      performRequest(
        "GET",
        `/projectTracking/getProjectTracking?name=${user.Name}`
      )
        .then((res) => {
          if (res.status === 200) {
            if (res.data && res.data?.projectTrackingData?.length > 0) {
              setTimeLines(res.data?.projectTrackingData[0]);
            }
          } else {
            Toast("error", "Error while getting Details!");
          }
          setLoading(false);
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  }, [clientDetails.clientName, user.Name]);

  useEffect(() => {
    if (user.Name) {
      performRequest(
        "GET",
        `/siteInspection/getSiteInspection?name=${user.Name}`
      )
        .then((res) => {
          if (res.status === 200) {
            if (
              res.data?.siteInspectionData &&
              res.data.siteInspectionData?.length > 0
            ) {
              setSiteInspectionData(res.data.siteInspectionData[0]);
              setQuotation(res.data.siteInspectionData[0]?.quotationNumber);
            }
          } else {
            Toast("error", "Error while getting Leads!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  }, [user.Name]);

  useEffect(() => {
    let totalProfilePercent = 0;
    if (clientDetails) {
      totalProfilePercent += 5;
    }
    if (quotation) {
      totalProfilePercent += 10;
    }
    if (siteInspectionData) {
      totalProfilePercent += 15;
    }
    if (timeLines && timeLines.workOrderUpload) {
      totalProfilePercent += 30;
    }
    if (totalProfilePercent) {
      setProfilePercent(totalProfilePercent);
    }
  }, [clientDetails, quotation, siteInspectionData, timeLines]);

  useEffect(() => {
    if (siteInspectionData.salesRelationshipManager) {
      performRequest(
        "GET",
        `/employeeManagement/getPOCDetailsByName?userName=${siteInspectionData.salesRelationshipManager}`
      )
        .then((res) => {
          if (res.status === 200) {
            setPOCData(res.data);
          } else {
            Toast("error", "Error while getting Details!");
          }
          setLoading(false);
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  }, [siteInspectionData]);
  const goToAgrementPage = () => {
    navigate(`/farm-construction/agreement`);
  };

  const goToQuotationPage = () => {
    if (quotation) {
      let id = getId(quotation);
      navigate(`/farm-construction/quotation?id=${id}`);
    }
  };

  const goToDPRPage = () => {
    if (siteInspectionData && siteInspectionData.siNumber) {
      let id = getId(siteInspectionData.siNumber);
      navigate(`/client-site-inspection/preview/${id}`);
    }
  };

  const goToFarmSupport = () => {
    navigate(`/agronomy-farm-support`);
  };

  if (loading) {
    return <LoadingPage />;
  }

  const ChartCard = ({ data }) => {
    const chartLabels = data?.map((order) =>
      new Date(order.createdAt).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
      })
    );
    const chartValues = data?.map((order) => Number(order));

    const chartData = {
      labels: chartLabels,
      datasets: [
        {
          label: "Total Revenue",
          data: chartValues,
          borderColor: "rgba(0, 123, 255, 0.8)",
          backgroundColor: "rgba(0, 123, 255, 0.2)",
          tension: 0.2,
          fill: true,
          pointRadius: 1,
          pointBackgroundColor: "rgba(0, 123, 255, 0.8)",
          borderWidth: 2,
        },
      ],
    };

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: true,
          callbacks: {
            label: function (context) {
              return `₹ ${context.raw}`;
            },
          },
        },
      },
      scales: {
        x: {
          display: false,
          grid: {
            display: false,
          },
        },
        y: {
          display: false,
          grid: {
            display: false,
          },
        },
      },
    };

    return (
      <div
        style={{
          height: "35px",
          marginLeft: "-7px",
          marginRight: "-7px",
          marginBottom: "-7px",
        }}
      >
        <Line data={chartData} options={chartOptions} />
      </div>
    );
  };

  const salesData = [134, 876, 567, 234, 789, 345, 654, 981, 456, 123, 888];
  const RevenueData = [765, 123, 456, 876, 908, 654, 987, 543, 234, 789, 678];
  const OrdersData = [345, 678, 987, 543, 234, 908, 765, 876, 432, 567, 678];
  const InventoryData = [789, 456, 321, 654, 876, 567, 432, 789, 543, 345, 678];

  return (
    <div className="Page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            {user.AdditionalRole == "farmer partner" && (
              <div className="row align-items-center">
                <div className="col-12 mb-3">
                  <div className="row g-3 row-deck">
                    <div className="col-lg-3 col-md-6 col-sm-6 col-6">
                      <div className="card bg-primary-lt text-dark">
                        <div className="card-body mb-0">
                          <div className="d-flex align-items-center">
                            <div className="subheader">Sales</div>
                          </div>
                          <div className="d-flex align-items-baseline">
                            <div className="h1 mb-0 me-2">
                              {pmgData?.totalOrders}
                            </div>
                            <div className="me-auto">
                              <span className="text-green d-inline-flex align-items-center lh-1">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="icon ms-1"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  strokeWidth="2"
                                  stroke="currentColor"
                                  fill="none"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <path
                                    stroke="none"
                                    d="M0 0h24v24H0z"
                                    fill="none"
                                  />
                                  <path d="M3 17l6 -6l4 4l8 -8" />
                                  <path d="M14 7l7 0l0 7" />
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                        <ChartCard value={salesData} data={salesData} />
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-6 col-sm-6 col-6">
                      <div className="card bg-primary-lt text-dark">
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <div className="subheader">Revenue</div>
                          </div>
                          <div className="d-flex align-items-baseline">
                            <div className="h1 mb-0 me-2">
                              ₹{pmgData?.totalRevenue}
                            </div>
                            <div className="me-auto">
                              <span className="text-green d-inline-flex align-items-center lh-1">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="icon ms-1"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  strokeWidth="2"
                                  stroke="currentColor"
                                  fill="none"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <path
                                    stroke="none"
                                    d="M0 0h24v24H0z"
                                    fill="none"
                                  />
                                  <path d="M3 17l6 -6l4 4l8 -8" />
                                  <path d="M14 7l7 0l0 7" />
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                        <ChartCard value={RevenueData} data={RevenueData} />
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-6 col-sm-6 col-6">
                      <div className="card bg-primary-lt text-dark">
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <div className="subheader">Orders</div>
                          </div>
                          <div className="d-flex align-items-baseline">
                            <div className="h1 mb-0 me-2">
                              {pmgData?.totalSales}
                            </div>
                            <div className="me-auto">
                              <span className="text-green d-inline-flex align-items-center lh-1">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="icon ms-1"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  strokeWidth="2"
                                  stroke="currentColor"
                                  fill="none"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <path
                                    stroke="none"
                                    d="M0 0h24v24H0z"
                                    fill="none"
                                  />
                                  <path d="M3 17l6 -6l4 4l8 -8" />
                                  <path d="M14 7l7 0l0 7" />
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                        <ChartCard value={OrdersData} data={OrdersData} />
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-6 col-sm-6 col-6">
                      <div className="card bg-primary-lt text-dark">
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <div className="subheader">Inventory</div>
                          </div>
                          <div className="d-flex align-items-baseline">
                            <div className="h1 mb-0 me-2">
                              {pmgData?.totalInventory}
                            </div>
                            <div className="me-auto">
                              <span className="text-green d-inline-flex align-items-center lh-1">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="icon ms-1"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  strokeWidth="2"
                                  stroke="currentColor"
                                  fill="none"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <path
                                    stroke="none"
                                    d="M0 0h24v24H0z"
                                    fill="none"
                                  />
                                  <path d="M3 17l6 -6l4 4l8 -8" />
                                  <path d="M14 7l7 0l0 7" />
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                        <ChartCard value={InventoryData} data={InventoryData} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div>
            <div className="grid g-0">
              <div className="g-col-lg-4 g-col-md-12 g-col-12">
                {/* WeatherCard aligned with clientDetails */}

                {weatherData && (
                  <div className="card mb-2">
                    <div className="card-body bg-primary-lt text-dark">
                      <WeatherCard weather={weatherData} />
                    </div>
                  </div>
                )}
                <div className="card mb-2">
                  <div className="card-body">
                    {profilePercent && (
                      <div className="w-100">
                        <h3 className="p-0 mb-1">Profile progress:</h3>
                        <div className="progress progress-sm">
                          <div
                            className="progress-bar bg-primary"
                            role="progressbar"
                            style={{ width: `${profilePercent}%` }}
                          ></div>
                        </div>
                        <div>
                          <span>{profilePercent}% Complete</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="card">
                  <div className="card-body">
                    <h2 className="page-title">
                      {clientDetails?.businessName || clientDetails?.clientName}
                    </h2>

                    <ul className="list-unstyled mt-2">
                      {clientDetails?.businessGstNumber && (
                        <li>
                          <CiCreditCard1
                            className="fs-3 me-1"
                            style={{ color: "coral" }}
                          />
                          GST:{" "}
                          <span className="fw-bold">
                            {clientDetails.businessGstNumber}
                          </span>
                        </li>
                      )}
                      {clientDetails?.panNumber && (
                        <li>
                          <FaRegAddressCard
                            className="fs-3 me-1"
                            style={{ color: "blue" }}
                          />
                          Pan:{" "}
                          <span className="fw-bold">
                            {clientDetails.panNumber}
                          </span>
                        </li>
                      )}
                      {clientDetails?.clientEmail && (
                        <li>
                          <IoMailOutline
                            className="fs-3 me-1"
                            style={{ color: "red" }}
                          />{" "}
                          Email:{" "}
                          <span className="fw-bold">
                            {clientDetails.clientEmail}
                          </span>
                        </li>
                      )}
                      {clientDetails?.clientContactNumber && (
                        <li>
                          <MdContactPhone
                            className="fs-3 me-2"
                            style={{ color: "green" }}
                          />
                          Contact:{" "}
                          <span className="fw-bold">
                            {clientDetails.clientContactNumber}
                          </span>
                        </li>
                      )}
                      {clientDetails?.billingAddress && (
                        <li>
                          <FaRegAddressBook
                            className="fs-3 me-1"
                            style={{ color: "purple" }}
                          />{" "}
                          Billing:{" "}
                          <span className="fw-bold">
                            {clientDetails.billingAddress}
                          </span>
                        </li>
                      )}
                      {clientDetails?.farmAddress && (
                        <li>
                          <FaRegAddressCard
                            className="fs-3 me-1"
                            style={{ color: "orange" }}
                          />{" "}
                          Farm:{" "}
                          <span className="fw-bold">
                            {clientDetails.farmAddress}
                          </span>
                        </li>
                      )}
                    </ul>
                    {pocData && (
                      <>
                        <span className="fs-4 fw-bold">
                          POC (Point of contact):
                        </span>
                        <br />
                        <span>
                          Name: {pocData.firstName + " " + pocData.lastName}
                        </span>
                        <br />
                        <span>Email: {pocData.emailId || "N/A"}</span>
                        <br />
                        <span>Mobile: {pocData.simCardNumber || "N/A"}</span>
                      </>
                    )}
                    <hr />

                    <h2 className="page-title mb-2">Documents</h2>
                    <div>
                      {quotation && (
                        <button className="btn m-1" onClick={goToQuotationPage}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="icon icon-tabler icons-tabler-outline icon-tabler-file-text"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                            <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
                            <path d="M9 9l1 0" />
                            <path d="M9 13l6 0" />
                            <path d="M9 17l6 0" />
                          </svg>
                          Quotation
                        </button>
                      )}
                      <button className="btn m-1" onClick={goToAgrementPage}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon icon-tabler icons-tabler-outline icon-tabler-file-text"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                          <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
                          <path d="M9 9l1 0" />
                          <path d="M9 13l6 0" />
                          <path d="M9 17l6 0" />
                        </svg>
                        Farm Constuction Agreement
                      </button>
                      {siteInspectionData && siteInspectionData.siNumber && (
                        <button onClick={goToDPRPage} className="btn m-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="icon icon-tabler icons-tabler-outline icon-tabler-file-text"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                            <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
                            <path d="M9 9l1 0" />
                            <path d="M9 13l6 0" />
                            <path d="M9 17l6 0" />
                          </svg>
                          Project Report
                        </button>
                      )}
                      <a
                        href={
                          "https://res.cloudinary.com/bsgfcooa/image/upload/v1754282080/WORK_ORDER-FARM-AGREEMENT_1_q13shn.pdf"
                        }
                        download
                      >
                        <button className="btn m-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="icon icon-tabler icons-tabler-outline icon-tabler-file-text"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                            <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
                            <path d="M9 9l1 0" />
                            <path d="M9 13l6 0" />
                            <path d="M9 17l6 0" />
                          </svg>
                          Work Order
                        </button>
                      </a>
                    </div>
                    {/* <hr />
                  <a
                    href="mailto:contact@kryzen.com"
                    className="btn btn-outline-primary "
                  >
                    Have Questions? Mail to contact@kryzen.com
                  </a> */}
                  </div>
                </div>
              </div>
              <div className="g-col-lg-8 g-col-md-12 g-col-12 d-flex flex-column ">
                <div className="card mb-4 bg-secondary-lt d-flex">
                  <div className="d-flex flex-row align-items-center">
                    <div className="col-2 d-flex justify-content-center d-none d-sm-block mb-0">
                      <img
                        src={
                          "https://res.cloudinary.com/dezupfsqo/image/upload/v1733491535/ads-sides_2_epehtu.png"
                        }
                        alt="graph"
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                        className="p-2"
                      />
                    </div>
                    <div className="card-body col-6 d-flex flex-column justify-content-between">
                      <div>
                        <h2
                          className={`fw-bold mb-2 ${
                            themeSet === "dark" ? "text-light" : "text-dark"
                          }`}
                        >
                          How to use Kryzen Softwares?
                        </h2>
                        <h4
                          className={`${
                            themeSet === "dark" ? "text-light" : "text-muted"
                          }`}
                        >
                          Watch a detailed video about using the entire Alpha
                          platform to maximize your experience in growing.
                        </h4>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end align-items-start">
                      <div>
                        <button
                          className="btn btn-primary me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#modal-team"
                        >
                          Watch Video
                        </button>
                        <div
                          className="modal modal-blur fade"
                          id="modal-team"
                          tabIndex="-1"
                          role="dialog"
                          aria-hidden="true"
                        >
                          <div
                            className="modal-dialog modal-lg modal-dialog-centered"
                            role="document"
                          >
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">
                                  How to use Kryzen Softwares
                                </h5>
                                <button
                                  type="button"
                                  className="btn-close"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                ></button>
                              </div>
                              <div className="modal-body text-center px-lg-0 px-md-2">
                                <iframe
                                  className="col-lg-10 col-sm-10"
                                  width="100%"
                                  src="https://www.youtube.com/embed/XHxALIU3OL4?si=xm2uArBjxWIEQc-4"
                                  title="YouTube video player"
                                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                  referrerPolicy="strict-origin-when-cross-origin"
                                  allowFullScreen
                                  style={{
                                    minHeight: "50vh",
                                    borderRadius: "10px",
                                  }}
                                ></iframe>
                              </div>
                              <div className="modal-footer bg-transparent border-1">
                                <button
                                  type="button"
                                  className="btn btn-secondary m-0"
                                  data-bs-dismiss="modal"
                                >
                                  Close
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {timeLines && (
                  <div className="text-center">
                    <div className="card w-100 border-none">
                      <div className="card-status-top bg-green"></div>
                      <div className="card-header">
                        <h3 className="card-title">
                          Your Project Development Timeline
                        </h3>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-vcenter text-start">
                          <thead>
                            <tr>
                              <th>Sr.</th>
                              <th>Status</th>
                              <th>Action</th>
                              <th>Responsible Person</th>
                            </tr>
                          </thead>
                          <tbody>
                            {timeLines?.taskList?.map((item, index) => {
                              const Index = index + 1;
                              return (
                                <tr key={index}>
                                  <td>{Index}</td>
                                  <td>
                                    <div>
                                      {`Completed: ${
                                        item?.completionDate || "N/A"
                                      }`}
                                      <br className="d-sm-none" />
                                      {item?.completionDate && (
                                        <span className="badge bg-success text-light ms-0 ms-sm-5 d-block d-sm-inline">
                                          In time
                                        </span>
                                      )}
                                    </div>
                                  </td>

                                  <td>{item?.taskName}</td>
                                  <td>{item?.responsibleStaff || "N/A"}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
                {!timeLines && (
                  <div className="text-center">
                    <div className="card w-100 border-none text-start p-4 mt-4">
                      <h2>
                        Your project development either completed or not
                        initiated.
                      </h2>
                      <span className="fs-2">
                        To get any kind of support or query
                      </span>
                      <button
                        onClick={goToFarmSupport}
                        className="btn btn-primary mt-2 align-self-start"
                      >
                        VISIT FARM SUPPORT
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default FarmConstructionAgreement;
